import palette from '../palette';

const MuiCheckbox = {
  root: {
    '&.MuiCheckbox-root.MuiCheckbox-colorSecondary.Mui-checked': {
      color: palette.selected.primary,
    },
  },
};

export default MuiCheckbox;
